export const CANGURO_LOGO_URL = '/images/logos/canguro-logo.svg';
export const CANGURO_LOGO_BLACK_URL = '/images/logos/canguro-logo-black.svg';
export const CANGURO_ICON_URL = '/images/logos/canguro-icon.svg';

/** Fondo animado (señal TNO / retail) */
export const ANIMATED_COVER_URL =
  'https://files.tnonetwork.com/shows/animated_cover/franquiciasenvenezuela.mp4';

export const ANIMATED_COVER_POSTER =
  'https://files.tnonetwork.com/shows/cover/franquiciasenvenezuela.jpg';
